import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareBoardViewNotFoundRoute: InvariantJiraRoute = {
	name: 'software-board-view-not-found',
	exact: true,
	path: '/jira/software/projects/:projectKey/boards/:boardId/not-found',
};
